import { useCallback, useEffect, useState } from 'react';
import { NOOP } from '../utils';
var useNextInvalidationTimestamp = function (getNextInvalidationTimestamp) {
    var _a = useState(null), nextInvalidationTimestamp = _a[0], setNextInvalidationTimestamp = _a[1];
    var updateInvalidationTimestamp = useCallback(function () { return setNextInvalidationTimestamp(getNextInvalidationTimestamp()); }, [getNextInvalidationTimestamp]);
    useEffect(function () {
        if (nextInvalidationTimestamp) {
            var timeout_1 = setTimeout(function () {
                updateInvalidationTimestamp();
            }, nextInvalidationTimestamp - Date.now());
            return function () { return clearTimeout(timeout_1); };
        }
        updateInvalidationTimestamp();
        return NOOP;
    }, [nextInvalidationTimestamp, updateInvalidationTimestamp]);
    return nextInvalidationTimestamp;
};
export default useNextInvalidationTimestamp;
